import { useTranslation } from 'react-i18next';

export default function TableTap(){
  const {t} = useTranslation();
  const prefix = 'optimizers.company.ti.products.6.details.table.';

  const middleTd = 'lg:w-[210px] px-4 py-4 text-gray-600 bg-gray-100 text-xs lg:text-sm';
  const lastTd = 'lg:w-[340px] px-4 py-4 text-gray-600 text-xs lg:text-sm border border-t-gray400 border-r-transparent';

  const getTrs = (start, count)=>{
    const trs = [];
    for(let i = 0; i < count*2; i+=2){
      trs.push((
        <tr key={i+start} className='border border-t-gray-700'>
          <td className={middleTd}>{t(`${prefix}${i+start}`)}</td>
          <td className={lastTd}>{t(`${prefix}${i+start+1}`)}</td>
        </tr>
      ));
    }
    return trs;
  }
  const trs1 = getTrs(4, 2);
  const trs2 = getTrs(11, 3);

  return (
    <table>
      <tbody>
        <tr className='border border-t-hover'>
          <th rowSpan={3} className='px-2 lg:w-[170px] bg-[#EDEDED] text-gray-600 text-sm lg:text-base text-light'>{t(`${prefix}1`)}</th>
          <td className={middleTd}>{t(`${prefix}2`)}</td>
          <td className='lg:w-[340px] px-4 py-4 text-gray-500 text-sm border border-t-hover border-r-transparent'>{t(`${prefix}3`)}</td>
        </tr>
        { trs1 }
        <tr className='border-[1.5px] border-t-gray-300 border-r-transparent'>
          <th rowSpan={4} className='px-2 lg:w-[170px] bg-[#EDEDED] text-sm lg:text-base text-gray-600 text-light'>{t(`${prefix}8`)}</th>
          <td className={middleTd}>{t(`${prefix}9`)}</td>
          <td className={lastTd}>{t(`${prefix}10`)}</td>
        </tr>
        { trs2 }
        <tr className='border-[1.5px] border-t-gray-300 border-r-transparent'>
          <th rowSpan={4} className='px-2 lg:w-[170px] bg-[#EDEDED] text-sm lg:text-base text-gray-600 text-light'>{t(`${prefix}17`)}</th>
          <td colSpan={2} className='px-4 py-4 text-xs text-gray-600 border lg:text-sm border-t-gray400 border-r-transparent'>{t(`${prefix}18`)}</td>
        </tr>
        <tr>
          <td colSpan={2} className='px-4 py-4 text-xs text-gray-600 border lg:text-sm border-t-gray400 border-r-transparent'>{t(`${prefix}19`)}</td>
        </tr>
        <tr>
          <td colSpan={2} className='px-4 py-4 text-xs text-gray-600 border lg:text-sm border-t-gray400 border-r-transparent'>{t(`${prefix}20`)}</td>
        </tr>
      </tbody>
    </table>
  );
}